import { useLocation } from 'react-router-dom';
import { useLgUp } from '../hooks/useMediaQuery';
import { PlayerPageSkeleton } from '../pages/Player/PlayerPageSkeleton';

/** 라우트 lazy 로딩 — 플레이어(모바일)는 스켈레톤, 그 외는 기존 텍스트 fallback */
export function AppRouteSuspenseFallback() {
  const { pathname } = useLocation();
  const lgUp = useLgUp();
  const isPlayerRoute = pathname.includes('/app/player/');

  if (isPlayerRoute && !lgUp) {
    return <PlayerPageSkeleton />;
  }

  return (
    <div className="soundpill-app-route-fallback flex min-h-[40vh] items-center justify-center text-sm text-white/50">
      Loading...
    </div>
  );
}
